import { useParams } from 'react-router-dom';

import { MilesTable } from 'components';

import { useGetRequest } from 'hooks';

import { CollectorOffersWithFrequencyCap } from 'codegen';

import { columns } from './lib';

export const FrequencyCaps = () => {
  const { snapId } = useParams();

  const { data, loading } = useGetRequest<CollectorOffersWithFrequencyCap>({ url: `/snaps/${snapId}/offers/caps` });

  return (
    <MilesTable
      loading={loading}
      columns={columns}
      dataSource={data?.offersWithFrequencyCap}
    />
  );
};
